import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'graphql',
  name: 'GraphQL',
  category: 'web',
  description: 'Execute GraphQL queries and mutations against any GraphQL API',
  icon: 'siGraphql',
  iconType: 'simple-icon',
  color: 'pink',
  version: '1.0.0',
  
  group: ['transform'],
  
  defaults: {
    name: 'GraphQL',
    color: '#e10098'
  },
  
  subtitle: '={{ $parameter.operation }} {{ $parameter.url }}',
  
  credentials: [
    {
      name: 'graphqlApi',
      required: false,
      displayName: 'GraphQL API',
      displayOptions: {
        show: {
          authentication: ['credential']
        }
      }
    }
  ],
  
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true
    }
  ],
  
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output'
    }
  ],
  
  tags: ['graphql', 'api', 'query', 'mutation', 'web'],
  
  comingSoon: false,
  
  // Tool-capable configuration for AI Agent
  toolCapable: {
    enabled: true,
    name: 'graphql_query',
    description: 'Execute GraphQL queries and mutations against GraphQL APIs. Supports variables, authentication, and pagination.',
    allowManualDescription: true,
    parameters: {
      url: {
        toolParamName: 'url',
        description: 'The GraphQL endpoint URL',
        required: true,
        type: 'string'
      },
      operation: {
        toolParamName: 'operation',
        description: 'Type of operation: query or mutation',
        required: false,
        type: 'string'
      },
      query: {
        toolParamName: 'query',
        description: 'The GraphQL query or mutation string',
        required: true,
        type: 'string'
      },
      variables: {
        toolParamName: 'variables',
        description: 'GraphQL variables as a JSON object',
        required: false,
        type: 'object'
      }
    },
    outputMapping: {
      data: 'GraphQL response data',
      errors: 'GraphQL errors if any occurred',
      hasErrors: 'Boolean indicating if errors occurred'
    }
  }
};

export default definition;
